import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "api/axiosInstance";
import { notify } from "../utils/notificationUtils";

export const listItems = createAsyncThunk(
    "items/list",
    async (filters = '', thunkAPI) => {
        try {
            const queryString = Object.keys(filters)
                .map((key) => `${key}=${filters[key]}`)
                .join("&");

            const { data } = await api.get(`/items?${queryString}`);

            return thunkAPI.fulfillWithValue(data);
        } catch (err) {
            const message = err.response?.data?.error || err.message;
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const fetchItems = createAsyncThunk(
    "items/fetch",
    async (data, thunkAPI) => {
        try {
            const { data: response } = await api.get("/items/sale", data);
            return thunkAPI.fulfillWithValue(response);
        } catch (err) {
            const message = err.response?.data?.error || err.message;
            return thunkAPI.rejectWithValue(message);
        }
    }
)

export const createItem = createAsyncThunk(
    "items/create",
    async (data, thunkAPI) => {
        try {
            const { data: response } = await api.post("/items", data);
            response.supplier_name = data.supplier_name;
            return thunkAPI.fulfillWithValue(response);
        } catch (err) {
            const message = err.response?.data?.error || err.message;
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const updateItem = createAsyncThunk(
    "items/update",
    async (data, thunkAPI) => {
        try {
            const { data: response } = await api.put("/items", data);
            response.supplier_name = data.supplier_name;
            return thunkAPI.fulfillWithValue(response);
        } catch (err) {
            const message = err.response?.data?.error || err.message;
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const deleteItem = createAsyncThunk(
    "items/delete",
    async (idItem, thunkAPI) => {
        try {
            const { data: response } = await api.delete(`/items/${idItem}`);
            return thunkAPI.fulfillWithValue(response);
        } catch (err) {
            const message = err.response?.data?.error || err.message;
            return thunkAPI.rejectWithValue(message);
        }
    }
);


const itemsSlice = createSlice({
    name: "items",
    initialState: {
        items: [],
        saleItems: [],
        selectedItem: null,
        types: [{ value: 'product', label: 'Producto' }, { value: 'service', label: 'Servicio' }]
    },
    reducers: {
        setSelectedItem: (state, action) => {
            state.selectedItem = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(listItems.fulfilled, (state, action) => {
                state.items = action.payload.map(item => {
                    item.type = state.types.find(obj => obj.value === item.type)?.label
                    item.stock = item.stock <= 0 ? '-' : item.stock

                    return item
                });
            })
            .addCase(fetchItems.fulfilled, (state, action) => {
                state.saleItems = action.payload
            })
            .addCase(createItem.fulfilled, (state, action) => {
                notify('Producto creado exitosamente', 'success')
                action.payload.type = state.types.find(obj => obj.value === action.payload.type)?.label
                state.items = [...state.items, action.payload];
            })
            .addCase(updateItem.fulfilled, (state, action) => {
                notify('Producto actualizado exitosamente', 'success')
                state.items = state.items.map(item => {
                    if (item.id === action.payload.id) {
                        action.payload.type = state.types.find(obj => obj.value === action.payload.type)?.label
                        return action.payload;
                    }
                    return item;
                });
            })
            .addCase(deleteItem.fulfilled, (state, action) => {
                notify('Producto eliminado exitosamente', 'success')
                state.items = state.items.filter(item => item.id !== action.payload.id);
            })
    }
});

export const {
    setSelectedItem
} = itemsSlice.actions;

export default itemsSlice.reducer;
